import React from "react";
import "./Navbar.css";
import Popup from "reactjs-popup";
import { SERVER_URL } from "../config/company";
import { useRef, useState, useEffect } from "react";

function Navbar(props) {
  const [currentYear, setCurrentYear] = useState("");
  const [yearIndex, setYearIndex] = useState(
    props.sessionObject.sessionVariables.financial_year_for_fetch
  );
  const [dateSelectorObj, setDateSelectorObj] = useState([]);

  const roleId = props.sessionObject.sessionVariables.role_id;

  const [backupTaskId, setBackupTaskId] = useState(null);
  const [backupLoading, setBackupLoading] = useState(false);
  const backupIntervalRef = useRef(null);

  const [backupPopupOpen, setBackupPopupOpen] = useState(false);
  const [backupPopupMsg, setBackupPopupMsg] = useState("");

  const [backupConfirmOpen, setBackupConfirmOpen] = useState(false);

  // console.log({ currentYear, yearIndex});
  // console.log(props.sessionObject.sessionVariables);
  // console.log(props.sessionObject.sessionVariables.financial_year_for_fetch);

  const getLocalFlag = () => {
    try {
      return localStorage.getItem("local_flag") === "true";
    } catch (e) {
      return false;
    }
  };
  const setLocalFlag = () => {
    try {
      localStorage.setItem("local_flag", JSON.stringify(!isLocal));
    } catch (e) {
      console.log("Errorr asdf", e.message);
    }

    setIsLocal(!isLocal);
  };

  useEffect(() => {
    console.log("reload");

    let selectorObj = [];

    const currDate = new Date();
    let currMonth = currDate.getMonth() + 1;
    let currYear =
      currDate.getFullYear().toString().substring(2) - (currMonth < 4);

    let yearRange = 4;
    let isCurrentYearSet = false;

    if (currYear == "21") {
      selectorObj.push({
        value: "22-23",
        label: "01/04/2022 - 31/03/2023",
      });
    }

    for (let i = 0; i < yearRange; i++) {
      let temp1 = currYear - i;
      let temp2 = temp1 + 1;
      let tempObj = {
        value: temp1 + "-" + temp2,
        label: "01/04/20" + temp1 + " - " + "31/03/20" + temp2,
      };

      if (!isCurrentYearSet) {
        isCurrentYearSet = true;
        setCurrentYear(temp1 + "-" + temp2);
        // setYearIndex(temp1 + "-" + temp2);
      }

      selectorObj.push(tempObj);
    }
    setDateSelectorObj(selectorObj);
    // console.log(branchInfo, yearIndex);
  }, []);

  useEffect(() => {
    // console.log("++++++++++++++", yearIndex);
    // const newYearToSet = {
    //     financial_year_for_fetch: yearIndex,
    // }
    props.sessionObject.saveSessionVariableByObject({
      financial_year_for_fetch: yearIndex,
    });
    window.dispatchEvent(new Event("Fyear-Changed"));
  }, yearIndex);

  const financialYearChanged = (e) => {
    const newYear = e.target.value;
    // console.log(e.target);
    setYearIndex(newYear);
  };

  const [isLocal, setIsLocal] = useState(getLocalFlag());

  const startBackup = async () => {
    try {
      setBackupLoading(true);

      const resp = await fetch(`${SERVER_URL}/backup/create-dump`, {
        method: "POST",
        headers: { Accept: "application/json" },
      });

      const data = await resp.json();

      if (!resp.ok || !data?.task_id) {
        throw new Error("Backup start failed");
      }

      setBackupTaskId(data.task_id);
      setBackupPopupMsg("Backup scheduled. Please wait…");
      setBackupPopupOpen(true);
    } catch (err) {
      console.error(err);
      setBackupLoading(false);
      setBackupPopupMsg("Failed to start backup");
      setBackupPopupOpen(true);
    }
  };

  const checkBackupStatus = async (taskId) => {
    try {
      const resp = await fetch(`${SERVER_URL}/backup/backup-status/${taskId}`);

      const data = await resp.json();
      if (!resp.ok) return;

      if (data.status === "completed") {
        clearInterval(backupIntervalRef.current);
        backupIntervalRef.current = null;
        setBackupLoading(false);
        setBackupTaskId(null);

        setBackupPopupMsg("Backup completed successfully.");
        setBackupPopupOpen(true);

        window.location.href = `${SERVER_URL}/backup/download-backup/${taskId}`;
      }

      if (data.status === "failed") {
        clearInterval(backupIntervalRef.current);
        backupIntervalRef.current = null;
        setBackupLoading(false);
        setBackupTaskId(null);

        setBackupPopupMsg(data.message || "Backup failed");
        setBackupPopupOpen(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!backupTaskId) return;

    checkBackupStatus(backupTaskId);

    backupIntervalRef.current = setInterval(() => {
      checkBackupStatus(backupTaskId);
    }, 10000);

    return () => {
      if (backupIntervalRef.current) clearInterval(backupIntervalRef.current);
    };
  }, [backupTaskId]);

  return (
    <nav className="navbar">
      <Popup open={backupConfirmOpen} modal closeOnDocumentClick={false}>
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">Confirm Backup</div>
            <div className="pop-up-content">
              Are you sure you want to take backup?
            </div>
            <div className="pop-up-actions">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupConfirmOpen(false);
                  startBackup();
                  close();
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupConfirmOpen(false);
                  close();
                }}
              >
                No
              </button>
            </div>
          </div>
        )}
      </Popup>

      <Popup open={backupPopupOpen} modal closeOnDocumentClick={false}>
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">Backup Status</div>
            <div className="pop-up-content">{backupPopupMsg}</div>
            <div className="pop-up-actions">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setBackupPopupOpen(false);
                  close();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </Popup>

      <ul className="navbar-nav">{props.children}</ul>
      <div className="navbar-branch" style={{ whiteSpace: "nowrap" }}>
        F. Year:
        <select
          className="navbar-branch"
          style={{
            backgroundColor: "#23293e",
            color: yearIndex == currentYear ? "lemonchiffon" : "red",
            fontFamily: "roboto",
          }}
          value={yearIndex}
          onChange={financialYearChanged}
        >
          {dateSelectorObj.map((date) => (
            <option
              value={date["value"]}
              key={date["value"]}
              style={{
                color: date.value == currentYear ? "lemonchiffon" : "red",
              }}
            >
              {date.label}
            </option>
          ))}
        </select>
      </div>
      {/* <div className="navbar-branch">
      Branch: {JSON.parse(sessionStorage.getItem("branch_name"))["branch_name"].toUpperCase()}
      </div> */}
      {/* <div className="navbar-branch">
      User: {JSON.parse(sessionStorage.getItem("user_name"))["user_name"].toUpperCase()}
      </div> */}
      {/* <button className="log-out-container" onClick={setLocalFlag}>
        {isLocal ? "Local" : "Global"}
      </button> */}
      {[1, 2].includes(roleId) && (
        <button
          className="log-out-container"
          onClick={() => setBackupConfirmOpen(true)}
          disabled={backupLoading}
          style={{ marginRight: "10px" }}
        >
          {backupLoading ? "Processing..." : "Backup"}
        </button>
      )}

      <button className="log-out-container" onClick={props.handleLogout}>
        Logout
      </button>
    </nav>
  );
}

export default Navbar;
